import { render } from "./TooltipTrigger.vue?vue&type=template&id=6c87a652&ts=true"
import script from "./TooltipTrigger.vue?vue&type=script&setup=true&lang=ts"
export * from "./TooltipTrigger.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/tooltip/TooltipTrigger.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6c87a652"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6c87a652', __exports__)) {
    api.reload('6c87a652', __exports__)
  }
  
  module.hot.accept("./TooltipTrigger.vue?vue&type=template&id=6c87a652&ts=true", () => {
    api.rerender('6c87a652', render)
  })

}


export default __exports__